import { IonIcon } from '@ionic/react';
import { lockClosed, personCircle } from 'ionicons/icons';
import { useState } from 'react';
import { VStack } from 'reaction';
import { verifyPassword } from 'utils/crypto';
import FullOverlay from './FullOverlay';
import { TextField, PasswordField } from 'components/core/InputField';
import { useOverlay } from './OverlayProvider';
import styles from './AuthenticationOverlay.module.css';

function AuthenticationOverlay() {
    const [user, setUser] = useState('Viraj Shah');
    const [password, setPassword] = useState('');

    const { opener } = useOverlay();

    return (
        <FullOverlay id={1} title='Locked Content'>
            <VStack
                style={{
                    width: 'fit-content',
                }}>
                <IonIcon icon={lockClosed} className={styles.Icon} />
                <h1 className={styles.CallToAction}>Enter Credentials</h1>
                <TextField
                    icon={personCircle}
                    value={user}
                    onChange={setUser}
                    className={styles.UsernameEmailInput}
                    clearButton
                />
                <PasswordField
                    icon={lockClosed}
                    value={password}
                    onChange={setPassword}
                    onGoButtonClick={() => {
                        verifyPassword(user, password).then(user => {
                            if (user) {
                                opener(null);
                            }
                        });
                    }}
                    className={styles.PasswordInput}
                    goButton
                />
            </VStack>
        </FullOverlay>
    );
}

export default AuthenticationOverlay;
